import { runPendingCheckout } from '../checkout/pendingCheckout';
import { postSignInPath } from '../organisations/pendingJoinCode';

/**
 * The post-success block from Google, LinkedIn and magic-link callbacks.
 * Pending checkout keys come from sessionStorage only. A missing checkout
 * URL falls through to chat. This is not Login.js handlePostAuthRedirect.
 * An organisation member (access.can_purchase === false) never starts a
 * checkout: they get the same refusal message as the server's 403 (which
 * also clears the pending keys) and continue to chat. A pending checkout
 * with no exam goes to /pricing (there is no default exam), and an exam the
 * user already owns (access.owned) goes to its practice page.
 */
export async function continuePendingCheckoutOrChat({ navigate, user }) {
  let outcome = { action: 'none' };
  try {
    outcome = await runPendingCheckout(user);
  } catch (checkoutErr) {
    console.error('SSO checkout redirect error:', checkoutErr);
  }
  if (outcome.action === 'redirect') {
    window.location.href = outcome.url;
    return;
  }
  if (outcome.action === 'practice') {
    navigate(`/practice/${outcome.exam}`, { replace: true });
    return;
  }
  if (outcome.action === 'pricing') {
    navigate('/pricing', { replace: true });
    return;
  }

  const pendingReturnTo = sessionStorage.getItem('returnTo');
  if (pendingReturnTo && pendingReturnTo.startsWith('/')) {
    sessionStorage.removeItem('returnTo');
    navigate(pendingReturnTo, { replace: true });
    return;
  }

  // The admin role decides, as the server's admin gate does; an email domain
  // grants nothing (signup does not verify an address).
  const isCertAdmin = user?.role === 'certadmin' || user?.role === 'admin';
  const defaultPath = isCertAdmin ? '/cert-portal' : '/chat';

  navigate(postSignInPath(defaultPath), { replace: true });
}
